import gql from 'graphql-tag';

export default gql`
  query GetAllEateries($statusFilter: EateryStatus, $searchTerm: String) {
    eateries(
      orderBy: name_ASC
      where: { status: $statusFilter, OR: [{ name_contains: $searchTerm }, { description_contains: $searchTerm }] }
    ) {
      id
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllEateries.ts